import React, { use, useEffect, useState } from 'react'
import { Box, Grid, Tooltip, Typography } from '@mui/material';
import AddUser from '../popups/AddUser';
import ActionButton from '../../common/input-fields/ActionButton';
import AddIcon from '@mui/icons-material/Add';
import AltDataGridPro from '../../common/data-grids/ALTDataGrid';
import { GridActionsCellItem } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import AppBarMain from '../../common/navigation-bars/AppBarMain';
import secureLocalStorage from 'react-secure-storage';
import { getAllUsers } from '../../services/services';

const AdminDashboard = () => {

  //#region props
  const [openPopup,setOpenPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users,setUsers] = useState([]);

  //#region columns
  const columns = [
    { field: 'userFullName', headerName: 'Full Name', flex: 1 },
    { field: 'emailAddress', headerName: 'Email', flex: 1 },
    { field: 'phoneNumber', headerName: 'Phone Number', flex: 1 },
    { field: 'designation', headerName: 'Designation', flex: 1 },
    {
      id: 4,
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      cellClassName: 'actions',
      flex: 1,
      getActions: ({ id, row }) => {
        const getActionItems = (row) => {
          const actions = [
            <Tooltip title="Edit User Details">
              <GridActionsCellItem
                icon={<EditIcon />}
                label="View"
                className="textPrimary"
                onClick={() => { onViewEditProfileClick(row) }}
                color="inherit" />
            </Tooltip>,
          ];
          return actions;
        };

        return getActionItems(row);
      }
    },
  ];

  //#region click events
  const onViewEditProfileClick = (row) => {
    setSelectedUser(row);
    setOpenPopup(true);
  }

  const handleOpenPopup = () => {
    setOpenPopup(true);
  }

  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedUser(null);
  }

  //#region api get calls
  const getUsers = async () => {
    const response = await getAllUsers();
    if (response.status === 200) {
      setUsers(response.data);
    } else {
      console.error("Failed to fetch users", response);
    }
  }

  //#region useeffect
  useEffect(() => {
    getUsers();
  }, []);

  //#region styles
  const styles = {
    welcome: {
      color: '#377dce', // match reference blue
      fontWeight: 400,
      fontSize: 15,
      marginBottom: 0,
      display: 'block',
      lineHeight: 1.2,
    },
    dashboardTitle: {
      fontWeight: 600,
      fontSize: 36,
      color: '#232b36',
      margin: 0,
      letterSpacing: '-0.5px',
      fontFamily: 'inherit',
    },
  };

  //#region return
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBarMain isUserLoggedIn={true}></AppBarMain>
      <Grid container spacing={2} className="padding-40" >
        <Grid item xs={12} sx={{ width: '100%' }}>
         <div className='child-margin-5' style={{marginBottom: 8}}>
           <span style={styles.welcome}>Welcome Back, {secureLocalStorage.getItem("fullName")}</span>
           <div style={styles.dashboardTitle}>Super Admin Dashboard</div>
         </div>
        </Grid>
        <Grid item xs={12} sx={{ width: '100%' }}>
          <div className='white-card child-margin-15 padding-20'>
            <div className='space-between'>
              <Typography variant="h6">Users</Typography>
              <ActionButton
                label="Add User"
                icon={<AddIcon />}
                onClick={handleOpenPopup}
                variant="contained" />
            </div>
            <div className='height-400'>
              <AltDataGridPro
                columns={columns}
                rows={users?.map((item) => {
                  return {
                    id: item.userID,
                    ...item
                  }
                })} />
            </div>
          </div>
        </Grid>
      </Grid>
      {
        openPopup &&
        <AddUser
          open={openPopup}
          getUsers={getUsers}
          onClose={handleClosePopup} />
      }
      {
        selectedUser && openPopup &&
        <AddUser
          open={openPopup}
          getUsers={getUsers}
          onClose={handleClosePopup}
          selectedUser={selectedUser} /> 
      }
    </Box>
  )
}

export default AdminDashboard